<template>
  <div class="row row-height">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :height="height"
      :is-full-page="fullPage"
      :width="width"
      background-color="#6b6969"
      loader="dots"
    />
    <div class="col-lg-5 col-md-3 backImage d-none d-md-block">
      <router-link to="/">
        <img
          src="@/assets/logo_white.png"
          style="width: 120px"
          class="img-fluid"
          alt=""
        />
      </router-link>
    </div>
    <div class="col-lg-7 col-md-9 col-sm-12">
      <form class="pt-5" @submit.prevent="submitForm1" v-if="step === 1">
        <div class="col-md-12">
          <div class="pl-md-5 pr-md-5 pl-4 pr-4">
            <h3>Registration</h3>
            <p style="color: #b0b0b0">
              Create an account to access the learning portal
            </p>
          </div>
        </div>
        <hr />

        <section class="row min-height pl-md-5 pr-md-5 pl-4 pr-4">
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="first_name">FIRST NAME (S) *</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                id="first_name"
                v-model="data.first_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="last_name">LAST NAME *</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                id="last_name"
                v-model="data.last_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="gender">GENDER *</label> <br />
              <select
                class="form-control"
                id="gender"
                v-model="data.gender"
                required
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="email">EMAIL ADDRESS *</label> <br />
              <input
                type="email"
                class="w-100 form-control"
                id="email"
                v-model="data.email"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="autocomplete">CITY *</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                id="autocomplete"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="location">REGION *</label> <br />
              <select
                class="form-control"
                id="location"
                v-model="data.region"
                required
              >
                <option value="">Select your region</option>
                <option
                  v-for="(reg, i) in regions"
                  :key="i"
                  :value="reg.region"
                >
                  {{ reg.region }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="contact">PROFESSION *</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                v-model="data.profession"
                id="contact"
                required
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="company">COMPANY</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                id="company"
                v-model="data.company_info"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="education_level">LEVEL OF EDUCATION *</label> <br />
              <select
                required
                class="form-control"
                v-model="data.education_level"
                id="education_level"
              >
                <option value="BECE Certificate">BECE Certificate</option>
                <option value="WASSCE Certificate">WASSCE Certificate</option>
                <option value="Diploma">Diploma</option>
                <option value="Degree">Degree</option>
                <option value="Masters">Masters</option>
                <option value="Secondary School">Secondary School</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-4">
              <label for="phone">PHONE NUMBER *</label> <br />
              <input
                type="text"
                class="w-100 form-control"
                id="phone"
                v-model="data.phone_number"
                required
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="custom-file">
              <span>CV/RESUME *</span>
              <input
                type="file"
                class="custom-file-input"
                @change="getFile('resume')"
                required
                accept="application/pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                id="customFile"
              />
              <label class="custom-file-label mr-4" for="customFile"
                >Click to upload file</label
              >
            </div>
          </div>
          <div class="col-12" style="margin-top: 3rem">
            <hr />
          </div>

          <div class="col-md-12" style="margin-top: 1rem">
            <div class="row">
              <div class="col-6">
                <div class="mt-3">
                  <div class="progressBar active"></div>
                  <div class="progressBar"></div>
                  <div class="progressBar" style="width: 16px"></div>
                </div>
              </div>
              <div class="col-6 text-right">
                <button
                  type="button"
                  disabled
                  class="btn btn-default btn-circle mr-2"
                >
                  <i class="material-icons"> arrow_back </i>
                </button>
                <button
                  type="submit"
                  :disabled="isLoading"
                  class="btn btn-green btn-circle"
                >
                  <span class="material-icons"> arrow_forward </span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>
      <form class="pt-5" @submit.prevent="submitForm2" v-if="step === 2">
        <div class="col-md-12">
          <div class="pl-md-5 pr-md-5 pl-4 pr-4">
            <h3>Registration</h3>
            <p style="color: #b0b0b0">
              Create an account to access the learning portal
            </p>
          </div>
        </div>
        <hr />

        <section class="row min-height pl-md-5 pr-md-5 pl-4 pr-4">
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="business_facilitator"
                >ARE YOU CURRENTLY A BUSINESS DEVELOPMENT FACILITATOR OR COACH *
              </label>
              <br />
              <select
                required
                class="form-control"
                id="business_facilitator"
                v-model="data.business_facilitator"
              >
                <option
                  v-for="(option, i) in options"
                  :key="i"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12" v-if="data.business_facilitator">
            <div class="form-group mb-4">
              <label for="business"
                >If yes, how long have you been working as a business
                development facilitator or coach?</label
              >
              <br />
              <input
                required
                type="text"
                class="w-100 form-control"
                id="business"
                v-model="data.business_facilitation_period"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="support">HAVE YOU SUPPORTED ANY STARTUPS(S) *</label>
              <br />
              <select
                required
                class="form-control"
                id="support"
                v-model="data.supported_startup"
              >
                <option
                  v-for="(option, i) in options"
                  :key="i"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12" v-if="data.supported_startup">
            <div class="form-group mb-4">
              <label for="startup_supported"
                >IF YES, HOW MANY STARTUPS(S) HAVE YOU SUPPORTED SO FAR?</label
              >
              <br />
              <input
                type="number"
                required
                class="w-100 form-control"
                id="startup_supported"
                v-model="data.startup_no_supported"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="data.supported_startup">
            <div class="form-group mb-4">
              <label class="mb-1"
                >If yes, provide two (2) reference to the startup support? (
                Name of startup, Contact person and phone number)</label
              >
              <br />
              <label for="reference1">1. Reference Name</label>
              <input
                type="text"
                required
                v-model="reference_data.reference_1_name"
                class="w-100 form-control mb-2"
                id="reference1"
              />
              <label for="phone1">1. Phone</label>
              <input
                type="text"
                required
                v-model="reference_data.reference_1_phone"
                class="w-100 form-control mb-2"
                id="phone1"
              />
              <label for="reference2">2. Reference Name</label>
              <input
                type="text"
                required
                v-model="reference_data.reference_2_name"
                class="w-100 form-control mb-2"
                id="reference2"
              />
              <label for="phone2">2. Phone</label>
              <input
                type="text"
                required
                v-model="reference_data.reference_2_phone"
                class="w-100 form-control"
                id="phone2"
              />
            </div>
          </div>

          <div class="col-12" style="margin-top: 3rem">
            <hr />
          </div>

          <div class="col-md-12" style="margin-top: 1rem">
            <div class="row">
              <div class="col-6">
                <div class="mt-3">
                  <div class="progressBar" style="width: 16px"></div>
                  <div class="progressBar active"></div>
                  <div class="progressBar" style="width: 22px"></div>
                </div>
              </div>
              <div class="col-6 text-right">
                <button
                  type="button"
                  class="btn btn-default btn-circle mr-2"
                  :disabled="isLoading"
                  @click="step--"
                >
                  <i class="material-icons"> arrow_back </i>
                </button>
                <button
                  :disabled="isLoading"
                  type="submit"
                  class="btn btn-green btn-circle"
                >
                  <span class="material-icons"> arrow_forward </span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>

      <form class="pt-5" @submit.prevent="submitForm3" v-if="step === 3">
        <div class="col-md-12">
          <div class="pl-md-5 pr-md-5 pl-4 pr-4">
            <h3>Almost done !</h3>
            <p style="color: #b0b0b0">
              Finish application to join the Ghana Startup Coach School
            </p>
          </div>
        </div>
        <hr />

        <section class="row min-height pl-md-5 pr-md-5 pl-4 pr-4">
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="employee"
                >ARE YOU AN EMPLOYEE OF ANY TECH OR BUSINESS HUB? *</label
              >
              <br />
              <select
                class="form-control"
                id="employee"
                v-model="data.employee"
                required
              >
                <option
                  v-for="(option, i) in options"
                  :key="i"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12" v-if="data.employee">
            <div class="form-group mb-4">
              <label for="hub_name">if yes, state the name of the hub? *</label>
              <br />
              <input
                type="text"
                required
                v-model="data.hub_name"
                class="w-100 form-control"
                id="hub_name"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="data.employee">
            <div class="form-group mb-4">
              <label for="role">if yes, state your current role? *</label>
              <br />
              <input
                type="text"
                required
                v-model="data.role"
                class="w-100 form-control"
                id="role"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="participate"
                >Why would you like to participate in our coach school? *</label
              >
              <br />
              <textarea
                v-model="data.participate_in_coach_school"
                required
                class="w-100 form-control"
                id="participate"
                style="height: 100px"
                cols="30"
                rows="10"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-4">
              <label for="benefit"
                >How will joining our Coach School benefit your business
                development career? *</label
              >
              <br />
              <textarea
                class="w-100 form-control"
                id="benefit"
                v-model="data.benefit"
                required
                style="height: 100px"
                cols="30"
                rows="10"
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="custom-file">
              <label for="video"
                >Upload a 1 min video of yourself explaining the importance of
                Business development/growth services to startups and why your
                interest? *</label
              >
              <input
                type="file"
                class="custom-file-input"
                id="video"
                @change="getFile('video')"
                required
              />
              <label
                class="custom-file-label mr-4"
                for="customFile"
                style="top: 50px"
                >Click to upload file</label
              >
            </div>
          </div>

          <div class="col-12" style="margin-top: 3rem">
            <hr />
          </div>

          <div class="col-md-12" style="margin-top: 1rem">
            <div class="row">
              <div class="col-6">
                <div class="mt-3">
                  <div class="progressBar" style="width: 16px"></div>
                  <div class="progressBar" style="width: 22px"></div>
                  <div class="progressBar active"></div>
                </div>
              </div>
              <div class="col-6 text-right">
                <button
                  type="button"
                  class="btn btn-green btn-circle mr-2"
                  @click="step--"
                  :disabled="isLoading"
                >
                  <i class="material-icons"> arrow_back </i>
                </button>
                <button
                  type="submit"
                  class="btn btn-orange btn-round pl-4 pr-4 pt-2 pb-2"
                  style="font-size: 14px"
                  :disabled="isLoading"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="successModalLable"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            <div class="row mb-5">
              <div class="col-md-10 offset-md-1 text-center">
                <img
                  src="@/assets/success_image.png"
                  class="img-fluid"
                  alt=""
                />
                <h5 class="text-green">Application submitted successfully</h5>
                <p class="text-dark">Check your email for the next step</p>
                <router-link
                  to="/"
                  class="btn btn-orange btn-round mt-3"
                  data-dismiss="modal"
                  >Back to Home</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      step: 1,
      regions: [],
      data: {
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        city: "",
        region: "",
        profession: "",
        company_info: "",
        education_level: "",
        phone_number: "",
        resume: "",
        business_facilitator: "",
        business_facilitation_period: "",
        supported_startup: "",
        startup_no_supported: "",
        startup_reference: "",
        employee: "",
        hub_name: "",
        role: "",
        participate_in_coach_school: "",
        benefit: "",
        video: "",
      },
      reference_data: {
        reference_1_name: "",
        reference_1_phone: "",
        reference_2_name: "",
        reference_2_phone: "",
      },

      options: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      cv_file: "",
      video_file: "",
      autocomplete: null,
      latlng: {
        lat: "",
        lng: "",
      },
      fullPage: true,
      height: 128,
      width: 128,
      isLoading: false,
    };
  },
  watch: {
    step: function (val) {
      if (val === 1) {
        this.$nextTick(() => {
          this.executeMap();
        });
      }
    },
  },
  components: {
    Loading,
  },
  methods: {
    nextStep() {
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    getFile(type) {
      if (type === "video") {
        this.video_file = event.target.files[0];
      } else {
        this.cv_file = event.target.files[0];
      }
      let file = window.$(".custom-file-input");
      let fileName = file.val().split("\\").pop();
      file.siblings(".custom-file-label").addClass("selected").html(fileName);
    },
    submitForm1() {
      this.data.city = window.$("#autocomplete").val();
      this.step++;
    },

    submitForm2() {
      if (this.data.supported_startup) {
        this.data.startup_reference = this.reference_data;
      } else {
        this.reference_data = "";
      }
      this.step++;
    },

    async submitForm3() {
      if (this.cv_file) {
        await this.uploadImage(this.cv_file)
          .then((res) => {
            if (res) {
              this.data.resume = res;
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "Error whiles uploading image...",
              icon: "error",
              confirmButtonText: "ok",
            });
            return "";
          });
      }
      if (this.video_file) {
        await this.uploadImage(this.video_file)
          .then((res) => {
            if (res) {
              this.data.video = res;
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "Error whiles uploading image...",
              icon: "error",
              confirmButtonText: "ok",
            });
            return "";
          });
      }
      this.submitRegistration();
    },
    getRegions() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_GTL_BASE_URL}/regions`)
        .then((res) => {
          this.regions = res.data;
          this.isLoading = false;

          if (typeof this.regions[0] !== "undefined") {
            this.data.region = this.regions[0].region;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    uploadImage(file) {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env["VUE_APP_FILE_UPLOAD"]}/upload`, formData)
          .then((res) => resolve(res.data["fileUrl"]))
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },

    executeMap() {
      this.autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {
          componentRestrictions: {
            country: "gh",
          },
          fields: [
            "address_components",
            "geometry",
            "icon",
            "name",
            "formatted_address",
          ],
        }
      );
      this.autocomplete.addListener("place_changed", this.onPlaceChanged);
    },
    onPlaceChanged() {
      let place = this.autocomplete.getPlace();
      this.latlng.lat = place.geometry.location.lat();
      this.latlng.lng = place.geometry.location.lng();
    },
    submitRegistration() {
      this.isLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_COMPANY_URL}/coach-school-registration`,
          this.data
        )
        .then((res) => {
          if (res.data.success) {
            window.$("#successModal").modal("show");
          }
        })
        .catch((err) => {
          console.log(err, "error");
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.$loadScript(
      "https://maps.googleapis.com/maps/api/js?key=" +
        process.env.VUE_APP_GOOGLE_MAPS_KEY +
        "&libraries=places"
    )
      .then(() => {
        this.executeMap();
      })
      .catch(() => {
        // Failed to fetch script
      });
    this.getRegions();
  },
};
</script>

<style scoped>
.row-height {
  height: 100vh;
}

.form-control,
.custom-select {
  background: rgba(228, 228, 228, 0.7);
  border: none;
  border-left: 2px solid #059ca6;
  height: 55px;
}

.form-group > label {
  font-size: 16px;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  /* height: calc(55px + 2px); */
  margin-bottom: 0;
  margin: auto;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  /* height: calc(55px + 2px); */
  margin: 0;
  opacity: 0;
}

.progressBar {
  width: 22px;
  height: 8px;
  background: #b0b0b0;
  border-radius: 8px;
  display: inline-block;
  margin-right: 5px;
}

.progressBar:nth-child(2) {
  width: 22px;
  height: 8px;
  background: #b0b0b0;
  margin-right: 5px;
}
.progressBar:nth-child(3) {
  width: 16px;
  height: 8px;
  background: #b0b0b0;
}

.progressBar.active {
  background: #f26526;
  width: 48px;
  height: 8px;
}

.custom-file-label {
  position: absolute;
  top: 32px;
  right: 0;
  left: 0;
  z-index: 1;
  height: 55px;
  padding-top: 1.3em;
  line-height: 1.3;
  color: #059ca6;
  background: rgba(228, 228, 228, 0.7);
  border: none;
  border-left: 2px solid #059ca6;
  border-radius: 0;
  box-shadow: none;
}

/* .custom-file-label span {
  margin-top: 20px;
} */

.custom-file-label::after {
  content: "" !important;
  border: none !important;
}

.font-color {
  color: rgba(0, 0, 0, 0.5);
}

.text-area {
  height: 85px;
}

.top {
  top: 55px;
}

.min-height {
  min-height: 80vh;
}

.backImage {
  background: url("../../public/assets/img/register_img.png") no-repeat center;
  background-size: cover;
  background-position-y: center;
}
</style>
